module.exports = __webpack_public_path__ + "media/images/level_introduction1-af9efabb139fd14e16eccb3ecc7fc510.png";